import React from 'react';
import "./Banner.css";

const Banner = () => {
  return (
    <div className='banner-cont'>
      <div>
        <div>
          <p className='banner-text'>Original Parts</p>
          <p className='banner-text'>for Your</p>
          <p className='banner-text banner-orange'>Motorcycle</p>
        </div>
      </div>
    </div>
  );
};

export default Banner;